import { format } from 'date-fns';
import { LABELS, PANEL_MONTHS, POST_DATE_FORMAT } from './constants';
import { launchTime } from './rules';
import type { Label, Post } from './types';

const NAME = "What's new";

/** A post's date as people read it, e.g. "14 Oct". */
export const postDate = (post: Post, pattern: string = POST_DATE_FORMAT): string => format(launchTime(post), pattern);

// The UI's own words. A post's words live in its own file under posts/.
export const WHATS_NEW_COPY = {
  labels: {
    [LABELS.new]: 'New',
    [LABELS.improved]: 'Improved',
    [LABELS.beta]: 'Beta',
    [LABELS.fixed]: 'Fixed'
  } as Record<Label, string>,
  button: {
    label: NAME,
    ariaLabel: (unread: number) => (unread ? `${NAME}, ${unread} unread` : NAME)
  },
  panel: {
    title: NAME,
    subtitle: 'New features and fixes in TradersConnect',
    close: 'Close',
    filterLabel: 'Filter updates',
    filters: { all: 'All', new: 'New', improved: 'Improved', fixed: 'Fixed' },
    unread: 'Unread',
    open: 'Take a look',
    tourBadge: (steps: number) => `${steps}-step tour`,
    markAllRead: 'Mark all as read',
    keptFor: `Kept for ${PANEL_MONTHS} months`,
    empty: 'Nothing here yet. New features and fixes will show up here.',
    emptyFilter: 'Nothing under this filter in the last few months.'
  },
  hint: {
    tryIt: 'Try it',
    dismiss: 'Dismiss'
  },
  popup: {
    close: 'Close',
    next: 'Next',
    back: 'Back',
    done: 'Done',
    seeAll: 'See all updates',
    guide: 'Read the guide',
    stepLabel: (step: number, steps: number, label: string) => `Step ${step} of ${steps} · ${label}`,
    stepAnnouncement: (step: number, steps: number, title: string) => `Step ${step} of ${steps}: ${title}`
  }
};
